import { useState, useEffect, useLayoutEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FaStar, FaRegStar } from "react-icons/fa";
import Modal from "./Modal";
import dayjs from "dayjs";
import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";

const HotelBooking = () => {
  const [loader, setLoader] = useState(false);
  const searchParams =
    JSON.parse(sessionStorage.getItem("hotelData_header")) || {};
  const location = useLocation();
  const selectedRoom = location.state?.selectedRoom; // Safe optional chaining
  const hotel = location.state?.hotel;

  console.log(selectedRoom);
  // console.log(hotel);

  const [hotelBooking, setHotelBooking] = useState([]);
  // // // console.log(hotelBooking);
  useLayoutEffect(() => {
    if (!hotel || !hotel.Rooms || hotel.Rooms.length === 0) {
      console.error("Hotel or Rooms data is missing!");
      return;
    }

    const fetchPriBooking = async () => {
      setLoader(true);
      try {
        const BookingCode = selectedRoom.BookingCode;
        // const  = BookingCode_1?.BookingCode; // Ensure BookingCode exists
        // // // console.log(BookingCode);
        if (!BookingCode) {
          console.error("BookingCode is missing!");
          return;
        }

        // // // console.log(BookingCode);

        const response = await fetch(
          "https://demo.taxivaxi.com/api/hotels/sbtHotelPreBook",
          {
            method: "POST",
            headers: {
              Origin: "http://localhost:3000",
              "Access-Control-Request-Method": "POST",
            },
            body: JSON.stringify({
              BookingCode: BookingCode,
              Language: "EN",
            }),
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        // console.log("Hotel data:", data);

        if (data.Status?.Code === 200) {
          setHotelBooking(data.HotelResult || []);
          setLoader(false);
        } else {
          setLoader(false);
          console.error(
            "Error fetching hotels:",
            data.response?.Status?.Description
          );
        }
      } catch (error) {
        setLoader(false);
        console.error("Error fetching hotels:", error);
      }
    };

    fetchPriBooking();
  }, []);
  const combinedHotels = useMemo(() => {
    if (!hotel && hotelBooking.length === 0) return [];

    const hotelArray = hotel ? [hotel] : [];

    const updatedHotel = hotelArray.map((hotelItem) => {
      const matchingHotel = hotelBooking.find(
        (booking) => booking.HotelCode === hotelItem.HotelCode
      );

      if (
        matchingHotel &&
        matchingHotel.HotelResult &&
        matchingHotel.HotelResult.length > 0
      ) {
        // Replace the Rooms array in the hotel object
        return {
          ...hotelItem,
          Rooms: matchingHotel.HotelResult[0].Rooms, // Use the new Rooms array
        };
      }

      // If no matching hotel is found, return the original hotel object
      return hotelItem;
    });

    // Merge updatedHotel and hotelBooking
    const mergedHotels = [...updatedHotel, ...hotelBooking].reduce(
      (acc, curr) => {
        const existingIndex = acc.findIndex(
          (item) => item.HotelCode === curr.HotelCode
        );

        if (existingIndex !== -1) {
          // Merge existing hotel with the new data
          acc[existingIndex] = { ...acc[existingIndex], ...curr };
        } else {
          // Add new hotel if not already in the list
          acc.push(curr);
        }

        return acc;
      },
      []
    );

    return mergedHotels;
  }, [hotel, hotelBooking]);
  // console.log(combinedHotels);
  const navigate = useNavigate();
  const agent_portal = sessionStorage.getItem("1");
  const [showGSTDetails, setShowGSTDetails] = useState(true);
  const [showTaxDetails, setShowTaxDetails] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showModal3, setShowModal3] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  // // console.log("Final Combined Hotels:", combinedHotels);
  const decodeHtmlEntities = (text) => {
    const textarea = document.createElement("textarea");
    textarea.innerHTML = text;
    return textarea.value;
  };

  const stripHtmlTags = (html) => {
    const decodedHtml = decodeHtmlEntities(html);
    return decodedHtml.replace(/<\/?[^>]+(>|$)/g, "");
  };

  const formatCancelPolicies = (CancelPolicies) => {
    if (!Array.isArray(CancelPolicies) || CancelPolicies.length === 0) {
      return ["No cancellation policies available."];
    }

    const today = new Date(); // Get today's date
    today.setHours(0, 0, 0, 0); // Remove time part for accurate comparison

    return CancelPolicies.filter((policy) => {
      // Convert FromDate to a Date object
      const policyDate = new Date(
        policy.FromDate.split(" ")[0].split("-").reverse().join("-")
      );
      return policyDate >= today; // Only keep future or current dates
    }).map((policy) => {
      const formattedDate = policy.FromDate.split(" ")[0]; // Extract only DD-MM-YYYY
      if (policy.ChargeType === "Fixed" && policy.CancellationCharge === 0) {
        return `Free Cancellation till check-in`;
      } else if (policy.ChargeType === "Fixed") {
        return `Booking will be cancelled from ${formattedDate} with a charge of ${policy.CancellationCharge}`;
      } else if (policy.ChargeType === "Percentage") {
        return `From ${formattedDate}, the cancellation charge is ${policy.CancellationCharge}%`;
      }
      return `Policy starts from ${formattedDate}`;
    });
  };

  const cleanRateConditions = (conditions) => {
    return conditions.map(
      (condition) =>
        decodeHtmlEntities(condition).replace(/<\/?[^>]+(>|$)/g, "") // Removes all HTML tags
    );
  };
  const formatDate1 = (date) => dayjs(date).format("ddd D MMM YYYY");
  const checkInTime =
    combinedHotels.length > 0
      ? combinedHotels[0].RateConditions?.find((condition) =>
          condition.includes("CheckIn Time-Begin")
        )
          ?.replace("CheckIn Time-Begin:", "")
          .trim()
      : "N/A";

  const checkOutTime =
    combinedHotels.length > 0
      ? combinedHotels[0].RateConditions?.find((condition) =>
          condition.includes("CheckOut Time")
        )
          ?.replace("CheckOut Time:", "")
          .trim()
      : "N/A";

  const [showDetails, setShowDetails] = useState(false);
  // Calculate number of nights
  const calculateNights = () => {
    if (!searchParams.checkIn || !searchParams.checkOut) return 0;
    const checkInDate = dayjs(searchParams.checkIn);
    const checkOutDate = dayjs(searchParams.checkOut);
    return checkOutDate.diff(checkInDate, "day");
  };

  const [nights, setNights] = useState(0);

  useEffect(() => {
    setNights(calculateNights());
  }, [searchParams.checkIn, searchParams.checkOut]);
  const renderStars = (rating) => {
    const maxStars = 5;
    const fullStars = Math.floor(rating);
    const emptyStars = maxStars - fullStars;

    return (
      <>
        {Array(fullStars).fill(<FaStar className="text-yellow-500" />)}
        {Array(emptyStars).fill(<FaRegStar className="text-gray-300" />)}
      </>
    );
  };
  const [showForm, setShowForm] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [guestDetails, setGuestDetails] = useState({
    title: "",
    firstName: "",
    lastName: "",
    isBelow12: false,
  });

  const [guests, setGuests] = useState([]); // Store all added guests
  const [selectedGuests, setSelectedGuests] = useState([]); // Store only selected guests
  const [error, setError] = useState("");

  const MAX_ADULTS = searchParams.Adults; // 2 (1 prefilled + 1 selectable)
  const MAX_CHILDREN = searchParams.Children; // 2
  const handleCheckboxChange = (index) => {
    setGuests((prevGuests) => {
      const updatedGuests = [...prevGuests];
      const currentGuest = updatedGuests[index];

      // Toggle isBelow12 value
      const newIsBelow12 = !currentGuest.isBelow12;

      // Update guest object
      updatedGuests[index] = {
        ...currentGuest,
        isBelow12: newIsBelow12,
      };

      // Recalculate adults and children count
      const newAdultsCount = updatedGuests.filter((g) => g.isAdults).length;
      const newChildrenCount = updatedGuests.filter((g) => g.isBelow12).length;

      // // // console.log("Adults:", newAdultsCount, "Children:", newChildrenCount);

      // Restrict max adults
      if (!newIsBelow12 && newAdultsCount > MAX_ADULTS) {
        alert(`You can only add up to ${MAX_ADULTS} adults.`);
        return prevGuests;
      }

      // Restrict max children
      if (newIsBelow12 && newChildrenCount > MAX_CHILDREN) {
        alert(`You can only add up to ${MAX_CHILDREN} children.`);
        return prevGuests;
      }

      return updatedGuests;
    });
  };
  const [person, setPerson] = useState({
    title: "",
    firstName: "",
    lastName: "",
    email: "",
    contact_no: "",
  });

  const [errors, setErrors] = useState({});
  const fullNumber = person.contact_no || "";
  const countryCode = fullNumber.startsWith("+")
    ? fullNumber.split(" ")[0]
    : "+91"; // Default to India
  const phoneNumber = fullNumber.replace(countryCode, "").trim(); // Remove country cod
  // Validation function
  // const validateForm = () => {
  //   const newErrors = {};
  //   // if (!person.title) newErrors.title = "required.";
  //   if (!person.firstName) newErrors.firstName = "First name is required.";
  //   if (!person.lastName) newErrors.lastName = "Last name is required.";
  //   if (!person.email) {
  //     newErrors.email = "Email is required.";
  //   } else if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(person.email)) {
  //     newErrors.email = "Invalid email format.";
  //   }
  //   if (!person.contact_no) {
  //     newErrors.contact_no = "Contact number is required.";
  //   } else if (!/^\d{10}$/.test(person.contact_no)) {
  //     newErrors.contact_no = "Contact number must be 10 digits.";
  //   }
  //   setErrors(newErrors);
  //   return Object.keys(newErrors).length === 0;
  // };

  // Handle input change
  // const handleChange2 = (e) => {
  //   const { name, value } = e.target;

  //   // Check for contact number field and allow only digits
  //   if (name === "contact_no") {
  //     // Allow only numbers
  //     const onlyDigits = value.replace(/\D/g, "");
  //     setPerson((prev) => ({
  //       ...prev,
  //       [name]: onlyDigits,
  //     }));

  //     // Clear error if valid contact number
  //     setErrors((prevErrors) => {
  //       const newErrors = { ...prevErrors };

  //       if (onlyDigits.length === 10) {
  //         delete newErrors.contact_no;
  //       }

  //       return newErrors;
  //     });
  //   } else {
  //     setPerson((prev) => ({
  //       ...prev,
  //       [name]: value,
  //     }));

  //     // Clear errors for other fields
  //     setErrors((prevErrors) => {
  //       const newErrors = { ...prevErrors };

  //       if (name === "title" && value) {
  //         delete newErrors.title;
  //       }

  //       if (name === "firstName" && value) {
  //         delete newErrors.firstName;
  //       }

  //       if (name === "lastName" && value) {
  //         delete newErrors.lastName;
  //       }

  //       if (name === "email") {
  //         if (value && /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(value)) {
  //           delete newErrors.email;
  //         }
  //       }

  //       return newErrors;
  //     });
  //   }
  // };
  const [peopleData, setPeopleData] = useState([
    { firstName: "", lastName: "", email: "", contact_no: "", gender: "" },
  ]);
  // const [registerGST, setRegisterGST] = useState([{ firstName: "", lastName: "", email: "", contact_no: "", gender: "" }]);
  useEffect(() => {
    const storedData = sessionStorage.getItem("peopleData");
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      if (parsedData.success && parsedData.response.length > 0) {
        const transformedData = parsedData.response.map((person) => ({
          firstName: person.people_name?.split(" ")[0] || "", // Extract first name
          lastName: person.people_name?.split(" ")[1] || "", // Extract last name
          email: person.people_email || "",
          contact_no: person.people_contact || "",
          title: person.gender === "Female" ? "Ms" : "Mr",
        }));
        setPeopleData(transformedData);
      }
    }
  }, []);

  const validateForm = () => {
    const newErrors = {};

    peopleData.forEach((person, index) => {
      const personErrors = {};
      if (!person.firstName) personErrors.firstName = "First name is required.";
      if (!person.lastName) personErrors.lastName = "Last name is required.";
      if (!person.email) {
        personErrors.email = "Email is required.";
      } else if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(person.email)) {
        personErrors.email = "Invalid email format.";
      }
      if (!person.contact_no) {
        personErrors.contact_no = "Contact number is required.";
    } else {
        // Remove any non-digit characters and extract only the last 10 digits
        const phoneNumberOnly = person.contact_no.replace(/\D/g, "").slice(-10);
    
        if (phoneNumberOnly.length !== 10) {
            personErrors.contact_no = "Contact number must be 10 digits.";
        }
    }
    

      if (Object.keys(personErrors).length > 0) {
        newErrors[index] = personErrors;
      }
    });
    if (!gstDetails.gstNo) {
      newErrors.gstNo = "GST Number is required.";
    } else if (!/^[0-9A-Z]{15}$/i.test(gstDetails.gstNo)) {
      newErrors.gstNo =
        "Invalid GST Number. Must be 15 alphanumeric characters.";
    }

    // Company Name Validation
    if (!gstDetails.cName) {
      newErrors.cName = "Company Name is required.";
    }

    // Company Address Validation
    if (!gstDetails.cAddr) {
      newErrors.cAddr = "Company Address is required.";
    }

    // Contact Number Validation (Only digits, 10-digit format)
    if (!gstDetails.contactNo) {
      newErrors.contactNo = "Contact Number is required.";
    } else if (!/^\d{10}$/.test(gstDetails.contactNo)) {
      newErrors.contactNo = "Invalid Contact Number. Must be 10 digits.";
    }

    // Email Validation
    if (!gstDetails.email) {
      newErrors.email = "Email is required.";
    } else if (!/^\S+@\S+\.\S+$/.test(gstDetails.email)) {
      newErrors.email = "Invalid email format.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange2 = (index, e) => {
    const { name, value } = e.target;

    setPeopleData((prevData) => {
      const updatedPeople = prevData.map((person, i) =>
        i === index ? { ...person, [name]: value } : person
      );
      // console.log("Updated People Data:", updatedPeople); // Debugging
      return updatedPeople;
    });

    // Clear errors dynamically when the user enters valid data
    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      if (newErrors[index]) {
        newErrors[index] = { ...newErrors[index], [name]: "" };
      }
      console.log("Updated Errors:", newErrors); // Debugging
      return newErrors;
    });
  };
  const handleNavigate = (e) => {
    if (!validateForm()) {
      // setShowGSTDetails(e.target.checked)
      setShowGSTDetails(true);
      return; // Stop execution if there are errors
    }
  
    // Store GST details in sessionStorage
    sessionStorage.setItem("gstDetails", JSON.stringify(gstDetails));
  
    // Ensure peopleData is passed correctly
    const personData = peopleData.length > 0 ? peopleData : [];
  
    sessionStorage.setItem("personData", JSON.stringify(personData));
  
    if (searchParams.payment == "1") {
      navigate("/HotelPayment", {
        state: { combinedHotels, personData }, // Pass both arrays
      });
    } else if (searchParams.payment == "0") {
      console.log("hello");
      navigate("/HotelBookingCompleted", { state: { combinedHotels } });
    }
  };
  

  const [gstDetails, setGstDetails] = useState({
    gstNo: "",
    cName: "",
    cAddr: "",
    contactNo: "",
    email: "",
  });
  const handleInputChange3 = (e) => {
    const { name, value } = e.target;

    setGstDetails((prevDetails) => ({
        ...prevDetails,
        [name]: value,
    }));

    // Remove the error only for the current field
    setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: value.trim() ? '' : prevErrors[name], // Clear error if value is entered
    }));
};


  // const handleSubmit2 = (e) => {
  //   // // console.log('hello');
  //   e.preventDefault();
  //   if (validateForm()) {
  //     setPersonDetails(person);
  //     // alert("Form submitted successfully!");
  //     // // // console.log("Person Data:", person);

  //     // You can call an API or perform further actions here
  //   }
  // };

  const handleAddNewGuest = () => {
    setShowForm(true);
    setIsEditing(false);
    setGuestDetails({
      title: "",
      firstName: "",
      lastName: "",
      isBelow12: false,
    });
  };
  const handleEditGuest = (guest) => {
    setShowForm(true);
    setIsEditing(true);
    setGuestDetails(guest);

    // Remove the guest being edited from the list
    setGuests((prevGuests) => prevGuests.filter((g) => g !== guest));
  };

  const handleSubmit = () => {
    if (
      guestDetails.firstName.trim() === "" ||
      guestDetails.lastName.trim() === ""
    ) {
      setError("Please enter guest's first and last name");
      return;
    }
    if (guestDetails.isBelow12) {
      // // // console.log("This guest is a child.");
    } else {
      // // // console.log("This guest is an adult.");
    }

    setGuests((prevGuests) => [...prevGuests, guestDetails]); // Add updated guest back
    setShowForm(false);
    setIsEditing(false);
    setError("");
  };

  const handleDone = () => {
    setShowModal3(false);
    // Store only the checked guests in the selectedGuests list
    const selected = guests.filter((guest) => guest.isBelow12);
    setSelectedGuests(selected);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setGuestDetails((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };
  const handleRemoveGuest = (index) => {
    setSelectedGuests((prevGuests) => prevGuests.filter((_, i) => i !== index));
  };
  // console.log(hotelBooking);
  return (
    <div className="search-bar3 h-20 w-full " id="widgetHeader2">
      <div className="purple-header">
        <h5 className="text-xl font-semibold text-white">
          Review your Booking
        </h5>
      </div>
      {loader ? (
        <>
          <div className="fixed inset-0 bg-white flex items-center justify-center z-50">
            <img
              src="../img/hotel_loader.gif"
              alt="Loading..."
              className="loader_size"
            />
          </div>
        </>
      ) : (
        <>
          {combinedHotels.map((hotelItem, index) => (
            <div key={index} className="mb-5 flex h-full floating-bookings">
              <div className="w-full space-y-5">
                <div className=" hotel_booking_cards max-w-[53rem] shadow-[4px_6px_10px_-3px_#bfc9d4] w-full bg-white border border-white-light dark:border-[#1b2e4b] dark:bg-[#191e3a] dark:shadow-none">
                  <div className="py-7 px-6 space-y-2">
                    <h5 className="text-[#3b3f5c] text-xl font-semibold dark:text-white-light">
                      {hotelItem.HotelName}
                    </h5>
                    
                    <div className="flex items-center space-x-1">
                      {renderStars(hotelItem.HotelRating)}
                    </div>
                    <div className="flex gap-2">
                      <img
                        src="../img/Address-icon.svg"
                        alt="img"
                        className="w-5 h-5"
                      />
                      <p className="text-xs">{hotelItem.Address}</p>
                    </div>
                    <div className="flex flex-cols gap-2 mb-3">
                      <div className="max-w-[25rem] w-full border border-white-light dark:border-[#1b2e4b]  box-color ">
                        <div className="py-2 px-6">
                          <div className="flex items-center justify-between gap-4 p-2">
                            {/* Check-in Section */}
                            <div className="text-center">
                              <h5 className="text-xs text-gray-500">
                                CHECK IN
                              </h5>
                              <span className="text-sm font-semibold">
                                {formatDate1(searchParams.checkIn)}
                              </span>
                              <p className="text-xs text-gray-500">
                                {checkInTime}
                              </p>
                            </div>

                            {/* Nights Count */}
                            <button className="border w-20 h-6 btn-color rounded-full text-xs font-medium transition duration-300">
                              {nights} {nights === 1 ? "Night" : "Nights"}
                            </button>

                            {/* Check-out Section */}
                            <div className="text-center">
                              <h5 className="text-xs text-gray-500">
                                CHECK OUT
                              </h5>
                              <span className="text-sm font-semibold">
                                {formatDate1(searchParams.checkOut)}
                              </span>
                              <p className="text-xs text-gray-500">
                                {checkOutTime}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="max-w-[25rem] w-full border border-white-light dark:border-[#1b2e4b] box-color p-4">
                        <div className="flex justify-center items-center text-center">
                          <h5 className="text-sm py-4 space-x-2">
                            <span className="font-bold">{nights}</span>{" "}
                            {nights === 1 ? "Night" : "Nights"} |
                            <span className="font-bold">
                              {searchParams.Adults}
                            </span>{" "}
                            Adults
                            {/* Show Children only if greater than 0 */}
                            {searchParams.Children > 0 && (
                              <>
                                |{" "}
                                <span className="font-bold">
                                  {searchParams.Children}
                                </span>{" "}
                                Children
                                {/* Show ChildAge only if there are valid ages */}
                                {Array.isArray(searchParams.ChildAge) &&
                                searchParams.ChildAge.length > 0 ? (
                                  <>
                                    {" "}
                                    |{" "}
                                    <span className="font-bold">
                                      {searchParams.ChildAge.map(
                                        (age) => `${age} yrs`
                                      ).join(", ")}
                                    </span>{" "}
                                  </>
                                ) : searchParams.ChildAge ? (
                                  ` | ${searchParams.ChildAge} yrs`
                                ) : (
                                  ""
                                )}
                              </>
                            )}
                            |{" "}
                            <span className="font-bold">
                              {searchParams.Rooms}
                            </span>{" "}
                            Rooms
                          </h5>
                        </div>
                      </div>
                    </div>

                    <div className="flex justify-between items-center">
                      {/* <h5 className="text-[#3b3f5c] text-lg font-semibold dark:text-white-light">
                        {selectedRoom.Name || "No Room Name Available"}
                      </h5> */}
                      <h5 className="text-[#3b3f5c] text-lg font-semibold dark:text-white-light">
  {(() => {
    const roomNames = selectedRoom.Name; // Assuming 'hotelItem.Name' is an array

    if (!roomNames || roomNames.length === 0) return "No Room Available";

    // Check if all room names are the same
    const allSame = roomNames.every(name => name === roomNames[0]);

    return allSame 
      ? `${roomNames[0]} `
      : roomNames.join(" | ");
  })()}
</h5>

                      <h5
                        className="text-[#785ef7] cursor-pointer text-sm font-semibold"
                        onClick={() => setShowModal2(true)}
                      >
                        See Inclusion
                      </h5>
                    </div>
                    {showModal2 && (
                      <Modal
                        title="Inclusion"
                        onClose={() => setShowModal2(false)}
                      >
                        <ul className="list-disc pl-5 text-sm text-gray-700 dark:text-white-light">
                          <li>{hotelItem?.Rooms[0]?.Inclusion}</li>
                        </ul>
                      </Modal>
                    )}
                    <ul className="list-disc text-black space-y-1">
                      {selectedRoom.Inclusion && (
                        <li className="text-sm">{selectedRoom.Inclusion}</li>
                      )}
                      <li className="text-sm">
                        {selectedRoom.MealType === "Room_Only"
                          ? "No Meals Included"
                          : selectedRoom.MealType === "BreakFast"
                          ? "Breakfast Included"
                          : selectedRoom.MealType}
                      </li>
                    </ul>

                    <div className="text-xs text-green-700">
                      {formatCancelPolicies(
                        selectedRoom.CancelPolicies || []
                      ).map((policy, idx) => (
                        <div key={idx} className="flex gap-2">
                          <img
                            src="../img/tick.svg"
                            className="w-3 h-5"
                            alt="✔"
                          />{" "}
                          {policy}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="max-w-[53rem] hotel_booking_cards shadow-[4px_6px_10px_-3px_#bfc9d4] w-full bg-white border border-white-light dark:border-[#1b2e4b] dark:bg-[#191e3a] dark:shadow-none">
                  <div className="py-7 px-6 space-y-2">
                    <h5 className="text-[#3b3f5c] text-xl font-semibold dark:text-white-light">
                      Important Information
                    </h5>

                    {/* Display First 4 RateConditions */}
                    <ul className="list-disc pl-5 text-sm text-gray-700 dark:text-white-light">
                      {hotelItem?.RateConditions?.slice(0, 4).map(
                        (condition, index) => (
                          <li key={index}>{stripHtmlTags(condition)}</li>
                        )
                      )}
                      <button
                        className="text-[#785ef7] text-sm font-semibold mt-2 cursor-pointer"
                        onClick={() => setShowModal(true)}
                      >
                        View More
                      </button>
                    </ul>

                    {/* View More Button */}
                  </div>
                </div>
                <div className="max-w-[53rem] hotel_booking_cards shadow-[4px_6px_10px_-3px_#bfc9d4] w-full bg-white border border-white-light dark:border-[#1b2e4b] dark:bg-[#191e3a] dark:shadow-none">
                  <div className="py-7 px-6 space-y-2">
                    <h5 className="text-[#3b3f5c] text-xl font-semibold dark:text-white-light mb-4">
                      Guest Details
                    </h5>

                    <form>
                      <div className="border-b">
                      {(peopleData.length > 0
                        ? peopleData
                        : [
                            {
                              title: "",
                              firstName: "",
                              lastName: "",
                              email: "",
                              contact_no: "",
                              gender: "",
                            },
                          ]
                      ).map((person, index) => (
                        <div key={index} className="guestForm">
                          {/* Show "Passenger 1", "Passenger 2", etc., only if there are multiple passengers */}
                          {peopleData.length > 1 && (
                            <h6 className="text-sm mb-2">
                              Passenger {index + 1}
                            </h6>
                          )}

                          <div className="guestsInfo__row mb-4">
                            <div className="makeFlex">
                              <div className="guestDtls__col width70 appendRight10">
                                <p className="font11 capText appendBottom10">
                                  Title
                                </p>
                                <div className="frmSelectCont">
                                  <select
                                    id={`title-${index}`}
                                    name="title"
                                    className="form-select"
                                    value={
                                      person.gender === "female"
                                        ? "Ms"
                                        : person.title || "Mr"
                                    }
                                    onChange={(e) => handleChange2(index, e)}
                                  >
                                    <option value="Mr">Mr</option>
                                    <option value="Mrs">Mrs</option>
                                    <option value="Ms">Ms</option>
                                  </select>
                                  {errors[index]?.title && (
                                    <span className="error text-xs">
                                      {errors[index].title}
                                    </span>
                                  )}
                                </div>
                              </div>
                              <div className="makeFlex column flexOne">
                                <div className="makeFlex">
                                  <div className="guestDtls__col width247 appendRight10">
                                    <div className="textFieldCol">
                                      <p className="font11 appendBottom10 guestDtlsTextLbl">
                                        <span className="font11 capText appendBottom10">
                                          FIRST NAME
                                        </span>
                                      </p>
                                      <input
                                        type="text"
                                        id={`fName-${index}`}
                                        name="firstName"
                                        className="frmTextInput"
                                        placeholder="First Name"
                                        value={person.firstName || ""}
                                        onChange={(e) =>
                                          handleChange2(index, e)
                                        }
                                      />
                                      {errors[index]?.firstName && (
                                        <span className="error text-xs">
                                          {errors[index].firstName}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                  <div className="guestDtls__col width247">
                                    <div className="textFieldCol">
                                      <p className="font11 appendBottom10 guestDtlsTextLbl">
                                        <span className="capText">
                                          LAST NAME
                                        </span>
                                      </p>
                                      <input
                                        type="text"
                                        id={`lName-${index}`}
                                        name="lastName"
                                        className="frmTextInput"
                                        placeholder="Last Name"
                                        value={person.lastName || ""}
                                        onChange={(e) =>
                                          handleChange2(index, e)
                                        }
                                      />
                                      {errors[index]?.lastName && (
                                        <span className="error text-xs">
                                          {errors[index].lastName}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Email & Mobile Number Section */}
                          <div className="guestDtls__row mb-4">
                            <div className="makeFlex">
                              <div className="guestDtls__col width327 appendRight10">
                                <div className="textFieldCol">
                                  <p className="font11 appendBottom10 guestDtlsTextLbl">
                                    <span className="capText">
                                      Email Address
                                    </span>
                                    <span className="grayText appendLeft3">
                                      (Booking voucher will be sent to this
                                      email ID)
                                    </span>
                                  </p>
                                  <input
                                    type="text"
                                    id={`email-${index}`}
                                    name="email"
                                    className="frmTextInput"
                                    placeholder="Email ID"
                                    value={person.email || ""}
                                    onChange={(e) => handleChange2(index, e)}
                                  />
                                  {errors[index]?.email && (
                                    <span className="error text-xs">
                                      {errors[index].email}
                                    </span>
                                  )}
                                </div>
                              </div>
                              <div className="guestDtls__col width327">
                                <p className="font11 capText appendBottom10">
                                  Mobile Number
                                </p>
                                <div className="makeFlex textLtr">
                                  <div className="guestDtls__contact ">
                                    <div className="country-code-container">
                                      <PhoneInput
                                        country={"in"}
                                        value={person.contact_no}
                                        onChange={(phone) => {
                                          handleChange2(index, {
                                            target: {
                                              name: "contact_no",
                                              value: phone,
                                            },
                                          });
                                        }}
                                        onlyCountries={[
                                          "us",
                                          "gb",
                                          "in",
                                          "au",
                                          "de",
                                          "fr",
                                          "jp",
                                        ]}
                                        disableDropdown={false}
                                        buttonClass="show-flag"
                                        containerClass="custom-phone-input"
                                        inputClass="contact-number-input"
                                      />
                                    </div>
                                  </div>
                                </div>
                                {errors[index]?.contact_no && (
                                  <span className="error text-xs">
                                    {errors[index].contact_no}
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                          {(index === 0 || index === 1) &&
                            peopleData.length > 1 && (
                              <hr className="passenger-separator" />
                            )}
                        </div>
                      ))}
                      </div>

                      <div className="guestDtls__row mb-4">
                        <div>
                          <div className="makeFlex hrtlCenter spaceBetween appendBottom15 mt-3 mb-4 ">
                            <span className="checkmarkOuter gap-2">
                              {/* <input
                                type="checkbox"
                                id="gstVisible"
                                className="w-4 h-4"
                                onChange={(e) =>
                                  setShowGSTDetails(e.target.checked)
                                }
                              /> */}
                              <label
                                className="makeFlex hrtlCenter gap-1"
                                htmlFor="gstVisible"
                              >
                                <span className="text-lg blackText appendRight5 font-semibold">
                                  Enter GST Details
                                </span>
                                {/* <span className="font11 grayText">
                                  (Optional)
                                </span> */}
                              </label>
                            </span>
                          </div>
                        </div>

                        {showGSTDetails && (
                          <div className="space-y-5">
                            <div className="makeFlex">
                              {/* GST Number */}
                              <div className="guestDtls__col width220 appendRight10">
                                <div className="textFieldCol">
                                  <p className="font11 appendBottom10 guestDtlsTextLbl">
                                    <span className="capText">
                                      Registration Number
                                    </span>
                                  </p>
                                  <div className="input-wrapper">
                                    <input
                                      type="text"
                                      name="gstNo"
                                      className="frmTextInput"
                                      placeholder="Enter Registration No."
                                      value={gstDetails.gstNo}
                                      onChange={handleInputChange3}
                                    />
                                    {errors.gstNo && (
                                      <span className="error text-xs">
                                        {errors.gstNo}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>

                              {/* Company Name */}
                              <div className="guestDtls__col width220 appendRight10">
                                <div className="textFieldCol">
                                  <p className="font11 appendBottom10 guestDtlsTextLbl">
                                    <span className="capText">
                                      Registered Company Name
                                    </span>
                                  </p>
                                  <div className="input-wrapper">
                                    <input
                                      type="text"
                                      name="cName"
                                      className="frmTextInput"
                                      placeholder="Enter Company Name"
                                      value={gstDetails.cName}
                                      onChange={handleInputChange3}
                                    />
                                    {errors.cName && (
                                      <span className="error text-xs">
                                        {errors.cName}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>

                              {/* Company Address */}
                              <div className="guestDtls__col width220 appendRight10">
                                <div className="textFieldCol">
                                  <p className="font11 appendBottom10 guestDtlsTextLbl">
                                    <span className="capText">
                                      Registered Company Address
                                    </span>
                                  </p>
                                  <div className="input-wrapper">
                                    <input
                                      type="text"
                                      name="cAddr"
                                      className="frmTextInput"
                                      placeholder="Enter Company Address"
                                      value={gstDetails.cAddr}
                                      onChange={handleInputChange3}
                                    />
                                    {errors.cAddr && (
                                      <span className="error text-xs">
                                        {errors.cAddr}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="makeFlex">
                              {/* Contact Number */}
                              <div className="guestDtls__col width220 appendRight10">
                                <div className="textFieldCol">
                                  <p className="font11 appendBottom10 guestDtlsTextLbl">
                                    <span className="capText">
                                      Registration Contact Number
                                    </span>
                                  </p>
                                  <div className="input-wrapper">
                                    <input
                                      type="text"
                                      name="contactNo"
                                      className="frmTextInput"
                                      placeholder="Enter Contact Number"
                                      value={gstDetails.contactNo}
                                      onChange={handleInputChange3}
                                    />
                                    {errors.contactNo && (
                                      <span className="error text-xs">
                                        {errors.contactNo}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>

                              {/* Company Email */}
                              <div className="guestDtls__col width220 appendRight10">
                                <div className="textFieldCol">
                                  <p className="font11 appendBottom10 guestDtlsTextLbl">
                                    <span className="capText">
                                      Registered Company Mail
                                    </span>
                                  </p>
                                  <div className="input-wrapper">
                                    <input
                                      type="text"
                                      name="email"
                                      className="frmTextInput"
                                      placeholder="Enter Company Mail"
                                      value={gstDetails.email}
                                      onChange={handleInputChange3}
                                    />
                                    {errors.email && (
                                      <span className="error text-xs">
                                        {errors.email}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>

                          </div>
                        )}
                      </div>
                      {selectedGuests.length > 0 && (
                        <div className=" border-gray-300 ">
                          <p className="cursor-pointer font-semibold mb-2">
                            Others Guests:
                          </p>
                          <div className="w-25">
                            <ul>
                              {selectedGuests.map((guest, index) => (
                                <li
                                  key={index}
                                  className="text-sm flex items-center justify-between gap-2 border-b "
                                >
                                  <span>
                                    {guest.firstName} {guest.lastName}
                                  </span>

                                  {/* Close (Cross) Icon to remove individual guests */}
                                  <button
                                    onClick={() => handleRemoveGuest(index)}
                                    className="text-gray-500 hover:text-red-600"
                                  >
                                    ✖
                                  </button>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      )}
                      {agent_portal === "0" && (
                        <div className="flex w-full items-center">
                          <div className="guestDtls__add">
                            <p
                              className="text-[#785ef7] cursor-pointer guestDtls__addBtn font-semibold"
                              onClick={() => setShowModal3(true)}
                            >
                              + Add Guest
                            </p>
                          </div>
                          {/* <div className="ml-auto">
                          <button onClick={handleSubmit2}
                            type="button"
                            className="bg-[#785ef7] w-full h-10 text-white px-2 rounded-md font-semibold text-sm transition duration-300 hover:bg-[#5a3ec8]"
                          >
                            Submit
                          </button>
                        </div> */}
                        </div>
                      )}

                      {showModal3 && (
                        <Modal
                          title={
                            <div className="flex items-center justify-between w-full">
                              <span className="text-lg font-medium">
                                Saved Guests
                              </span>
                              {!showForm && (
                                <span
                                  className="text-sm text-[#785ef7] cursor-pointer hover:underline"
                                  onClick={handleAddNewGuest}
                                >
                                  + Add New Guests
                                </span>
                              )}
                            </div>
                          }
                          onClose={() => setShowModal3(false)}
                        >
                          {showForm ? (
                            <>
                              <div className="max-w-[29rem] w-full border py-2 px-3 box-color">
                                <h6 className="font-semibold mt-2">
                                  {isEditing ? "Edit Guest" : "Add Guests"}
                                </h6>
                                <p className="text-xs">
                                  Name should be as per official govt. ID &
                                  travelers below 18 years of age cannot travel
                                  alone.
                                </p>
                                <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-2 mb-2">
                                  <div>
                                    <label htmlFor="gridState">Title</label>
                                    <select
                                      id="gridState"
                                      name="title"
                                      className="form-select"
                                      value={guestDetails.title}
                                      onChange={handleChange}
                                    >
                                      <option>Mr</option>
                                      <option>Mrs</option>
                                      <option>Ms</option>
                                    </select>
                                  </div>
                                  <div className="md:col-span-2">
                                    <label htmlFor="gridCity">Full Name</label>
                                    <div className="flex gap-2 add_gusts_box">
                                      <input
                                        id="gridCity"
                                        name="firstName"
                                        type="text"
                                        className="frmTextInputs"
                                        placeholder="First Name"
                                        value={guestDetails.firstName}
                                        onChange={handleChange}
                                      />
                                      <input
                                        id="gridZip"
                                        name="lastName"
                                        type="text"
                                        className="frmTextInputs"
                                        placeholder="Last Name"
                                        value={guestDetails.lastName}
                                        onChange={handleChange}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div>
                                  {error && (
                                    <p className="text-red-500 text-sm">
                                      {error}
                                    </p>
                                  )}
                                </div>

                                <div className="mb-2">
                                  <label className="inline-flex gap-2">
                                    <input
                                      type="checkbox"
                                      name="isBelow12"
                                      className="form-checkbox w-3 h-auto"
                                      checked={guestDetails.isBelow12}
                                      onChange={(e) =>
                                        setGuestDetails((prev) => ({
                                          ...prev,
                                          isBelow12: e.target.checked,
                                        }))
                                      }
                                    />
                                    <span className="text-xs">
                                      Below 12 years of age
                                    </span>
                                  </label>
                                </div>

                                <div className="flex justify-between mb-2">
                                  <button
                                    type="button"
                                    className="rounded-full btn-color"
                                    onClick={handleSubmit}
                                  >
                                    {isEditing
                                      ? "SAVE GUEST"
                                      : "ADD TO SAVED GUESTS"}
                                  </button>
                                </div>
                              </div>

                              {/* Show the guest list and "Done" button only if guests are added */}
                              {guests.length > 0 && (
                                <div className="h-full flex flex-col gap-4 mt-2">
                                  {guests.map((guest, index) => (
                                    <div
                                      key={index}
                                      className="border-b pb-2 flex justify-between items-center"
                                    >
                                      <label className="inline-flex gap-2 items-center">
                                        <input
                                          type="checkbox"
                                          name="isBelow12"
                                          className="form-checkbox w-3 h-auto"
                                        />
                                        <span className="text-sm">
                                          {guest.firstName} {guest.lastName}
                                        </span>
                                      </label>
                                      <img
                                        src="./img/Edit-01.svg"
                                        alt="edit"
                                        className="w-5 h-5 cursor-pointer"
                                        onClick={() => handleEditGuest(guest)}
                                      />
                                    </div>
                                  ))}

                                  <div className="flex justify-center mt-4">
                                    <button
                                      type="button"
                                      className="rounded-full btn-color_h1 h-8 px-4"
                                      onClick={handleDone} // ✅ Saves state after clicking "Done"
                                    >
                                      Done
                                    </button>
                                  </div>
                                </div>
                              )}
                            </>
                          ) : (
                            <div className="h-full flex flex-col gap-4">
                              {guests.length > 0 && (
                                <div className="h-full flex flex-col gap-4 mt-2">
                                  {guests.map((guest, index) => (
                                    <div
                                      key={index}
                                      className="border-b pb-2 flex justify-between items-center"
                                    >
                                      <label className="inline-flex gap-2 items-center">
                                        <input
                                          type="checkbox"
                                          name="isBelow12"
                                          className="form-checkbox w-3 h-auto"
                                          checked={guest.isAdults} // ✅ This correctly reflects the state
                                          onChange={() =>
                                            handleCheckboxChange(index)
                                          }
                                        />
                                        <span className="text-sm">
                                          {guest.firstName} {guest.lastName}
                                        </span>
                                      </label>
                                      <img
                                        src="./img/Edit-01.svg"
                                        alt="edit"
                                        className="w-5 h-5 cursor-pointer"
                                        onClick={() => handleEditGuest(guest)}
                                      />
                                    </div>
                                  ))}

                                  <div className="flex justify-center mt-4">
                                    <button
                                      type="button"
                                      className="rounded-full btn-color_h1 h-8 px-4"
                                      onClick={handleDone} // ✅ Saves state after clicking "Done"
                                    >
                                      Done
                                    </button>
                                  </div>
                                </div>
                              )}

                              {/* <div className="flex justify-center mt-4">
                                <button
                                  type="button"
                                  className="rounded-full btn-color_h1 h-8 px-4"
                                  onClick={handleDone}
                                >
                                  Done
                                </button>
                              </div> */}
                            </div>
                          )}
                        </Modal>
                      )}
                    </form>
                  </div>
                </div>
                {/* Modal for Full RateConditions */}
                {showModal && (
                  <Modal
                    title="All Hotel Rules"
                    onClose={() => setShowModal(false)}
                  >
                    <ul className="list-disc pl-5 text-xs text-gray-700 dark:text-white-light">
                      {cleanRateConditions(hotelItem?.RateConditions || []).map(
                        (condition, index) => (
                          <li key={index}>{condition}</li>
                        )
                      )}
                    </ul>
                  </Modal>
                )}
                <div className="max-w-[53rem] hotel_booking_cards  shadow-[4px_6px_10px_-3px_#bfc9d4] w-full bg-white border border-white-light dark:border-[#1b2e4b] dark:bg-[#191e3a] dark:shadow-none">
                  <div className="py-7 px-6 space-y-2">
                    <label className="inline-flex gap-2">
                      <input
                        type="checkbox"
                        name="isBelow12"
                        className="form-checkbox w-3 h-auto"
                        // checked={guestDetails.isBelow12 || false} // Prevents undefined issues
                        // onChange={handleChange}
                      />
                      <span className="text-xs">
                        By proceeding, I agree to Cotrav's User Agreement, Terms
                        of Service and Cancellation & Property Booking Policies.
                      </span>
                    </label>
                    <div>
                      {searchParams.payment == "1" && (
                        <button
                          type="button"
                          className="bg-[#785ef7] button_width h-10 text-white px-2 rounded-md font-semibold text-sm transition duration-300 hover:bg-[#5a3ec8]"
                          onClick={handleNavigate}
                        >
                          Pay To Proceed
                        </button>
                      )}
                      {searchParams.payment == "0" && (
                        <button
                          type="button"
                          className="bg-[#785ef7] button_width h-10 text-white px-2 rounded-md font-semibold text-sm transition duration-300 hover:bg-[#5a3ec8]"
                          onClick={handleNavigate}
                        >
                          Proceed
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="w-1/3 ">
                <div className="sticky top-0">
                  <div className="max-w-[19rem] hotel_booking_cards w-full bg-white border border-gray-300 dark:border-[#1b2e4b] dark:bg-[#191e3a] sticky top-5 shadow-[4px_6px_10px_-3px_#bfc9d4]">
                    <div className="py-2 px-6">
                      <h5 className="text-[#785ef7] text-lg font-semibold  dark:text-white-light">
                        Price Breakup
                      </h5>
                      {hotelItem?.Rooms?.[0]?.PriceBreakUp?.length > 0 ? (
                        <div className="dark:border-[#1b2e4b]">
                          {/* Room Rate */}
                          <div className="flex justify-between items-center border-b border-gray-300 dark:border-[#1b2e4b] py-1 relative">
                            <div className="text-sm text-gray-700 dark:text-white-light flex items-center gap-2">
                              <div>
                                <strong>1 Room x {nights} Nights</strong>
                                <br />
                                <span className="text-xs">Base price </span>
                              </div>

                              <img
                                src="../img/i_icon.svg"
                                className="w-4 h-5 cursor-pointer mb-3"
                                onMouseEnter={() => setShowDetails(true)}
                                onMouseLeave={() => setShowDetails(false)}
                              />
                            </div>
                            <p className="text-sm text-gray-700 dark:text-white-light font-semibold">
                              ₹
                              {hotelItem?.Rooms?.[0]?.PriceBreakUp?.[0]?.RoomRate?.toFixed(
                                2
                              )}
                            </p>

                            {/* Tooltip with Rates */}
                            {showDetails && (
                              <div className="absolute right-0 top-10 w-56 bg-white dark:bg-[#1b2e4b] border border-gray-300 dark:border-[#1b2e4b] shadow-md rounded-lg p-3 z-10">
                                <h6 className="text-sm font-semibold text-gray-800 dark:text-white mb-2">
                                  Rates Breakdown:
                                </h6>
                                {hotelItem?.Rooms?.[0]?.DayRates?.[0]?.map(
                                  (rate, idx) => (
                                    <div
                                      key={idx}
                                      className="flex justify-between text-xs text-gray-700 dark:text-white-light"
                                    >
                                      <p>Day {idx + 1}:</p>
                                      <p className="font-semibold">
                                        ₹{rate.BasePrice.toFixed(2)}
                                      </p>
                                    </div>
                                  )
                                )}
                              </div>
                            )}
                          </div>

                          {/* Agent Commission */}
                          {/* <div className="border-b border-gray-300 dark:border-[#1b2e4b] py-1 flex justify-between">
                          <p className="text-sm text-gray-700 dark:text-white-light">
                            <strong>Management Fees:</strong>
                          </p>
                          <p className="text-sm text-gray-700 dark:text-white-light font-semibold">
                            - ₹
                            {selectedRoom.PriceBreakUp?.[0]?.AgentCommission?.toFixed(
                              2
                            )}
                          </p>
                        </div> */}

                          {/* Tax Amount */}
                          <div className="border-b border-gray-300 dark:border-[#1b2e4b]  flex justify-between py-1 items-center relative">
                            <div className="flex  gap-1">
                              <p className="text-sm text-gray-700 dark:text-white-light flex items-center gap-2">
                                <strong>Tax Amount</strong>
                              </p>
                              <img
                                src="../img/i_icon.svg"
                                className="w-4 h-5 cursor-pointer"
                                onMouseEnter={() => setShowTaxDetails(true)}
                                onMouseLeave={() => setShowTaxDetails(false)}
                              />
                            </div>
                            <p className="text-sm text-gray-700 dark:text-white-light font-semibold">
                              ₹{hotelItem?.Rooms?.[0]?.TotalTax.toFixed(2)}
                            </p>

                            {/* Tax Breakdown Tooltip */}
                            {showTaxDetails && (
                              <div className="absolute right-0 top-10 w-56 bg-white dark:bg-[#1b2e4b] border border-gray-300 dark:border-[#1b2e4b] shadow-md rounded-lg p-3 z-10">
                                <h6 className="text-sm font-semibold text-gray-800 dark:text-white mb-2">
                                  Tax Breakdown:
                                </h6>
                                {hotelItem?.Rooms?.[0]?.PriceBreakUp?.[0]?.TaxBreakup?.map(
                                  (tax, idx) => (
                                    <div
                                      key={idx}
                                      className="flex justify-between text-xs text-gray-700 dark:text-white-light"
                                    >
                                      <p>
                                        {tax.TaxType.replace("Tax_", "")} (
                                        {tax.TaxPercentage}%)
                                      </p>
                                      <p className="font-semibold">
                                        ₹{tax.TaxableAmount.toFixed(2)}
                                      </p>
                                    </div>
                                  )
                                )}
                              </div>
                            )}
                          </div>

                          {/* Total Amount */}
                          <div className="py-1 flex justify-between ">
                            <p className="text-sm text-gray-700 dark:text-white-light">
                              <strong>Total Amount:</strong>
                            </p>
                            <p className="text-sm text-gray-700 dark:text-white-light font-semibold">
                              ₹{hotelItem?.Rooms?.[0]?.TotalFare}
                            </p>
                          </div>
                        </div>
                      ) : (
                        <p className="text-white-dark">
                          No Price Breakdown Available
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </>
      )}
    </div>
  );
};
export default HotelBooking;
